module.exports = __webpack_public_path__ + "307f43437c8fb0711e8acdc390acbeaa.svg";